import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "./useAuth";

interface DriverHomeBase {
  id: string;
  short_code: string;
  customer_id: string | null;
  city: string | null;
}

interface DriverProfile {
  id: string;
  name: string;
  email: string | null;
  slack_handle: string | null;
  manager: string | null;
  home_base_id: string | null;
  certification: "VO" | "NVO" | "Manual" | null;
  shift: "AM" | "PM" | null;
  created_at: string;
  updated_at: string;
  home_base: DriverHomeBase | null;
}

export function useDriverProfile() {
  const { user } = useAuth();

  const { data: driver, isLoading, error } = useQuery({
    queryKey: ["driver-profile", user?.email],
    queryFn: async () => {
      if (!user?.email) return null;
      
      const { data, error } = await supabase
        .from("drivers")
        .select(`
          *,
          home_base:locations(id, short_code, customer_id, city)
        `)
        .eq("email", user.email)
        .maybeSingle();
      
      if (error) throw error;
      return data as DriverProfile | null;
    },
    enabled: !!user?.email,
  });

  return { driver, isLoading, error };
}
